import { ho } from "apis/homeowner/ho";
import { WebApiRequest, HTTP_GET, HTTP_POST, HTTP_DELETE, HTTP_PUT } from "tools/webservice";
import { createRequestCoalescer } from "tools/requestCoalescer";

const detailedHistoryCoalescer = createRequestCoalescer();
const customerDetailedHistoryCoalescer = createRequestCoalescer();
const activeRequest = { current: true };

export const getDetailedHistory = (controlNumber, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: ho.detailedHistory(controlNumber),
  successCallback,
  mountedRef,
});

export const getDetailedHistoryCoalesced = (controlNumber, successCallback, errorCallback = null) =>
  detailedHistoryCoalescer.run(
    controlNumber,
    (resolve) => getDetailedHistory(controlNumber, resolve, activeRequest),
    successCallback,
    errorCallback,
  );
export const addCaseNote = (controlIdNumber, caseNoteType, payload, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  endpoint: `/case-notes/${controlIdNumber}/${caseNoteType}`,
  payload,
  successCallback,
  mountedRef,
});
export const getAppraisalQARejections = (controlNumber, successCallback, isFetchingCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: ho.appraisalQaRejections(controlNumber),
  successCallback,
  isFetchingCallback,
  mountedRef,
});
export const getAttachments = (controlNumber, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: ho.getAttachment(controlNumber),
  successCallback,
  mountedRef,
});
export const generatePdf = (controlNumber, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: ho.generatePdf(controlNumber),
  successCallback,
  mountedRef,
});
export const regeneratePdf = (controlNumber, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: ho.regeneratePdf(controlNumber),
  successCallback,
  mountedRef,
});
export const deleteAttachment = (controlNumber, filename, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_DELETE,
  endpoint: ho.deleteAttachment(controlNumber, filename, 0),
  successCallback,
  mountedRef,
});
export const resolveAppraisalQARejection = ({ appraisalSurveyId, id }, payload, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  endpoint: ho.appraisalQaRejectionResolve(appraisalSurveyId, id),
  payload,
  successCallback,
  mountedRef,
});
export const addAttachmentRequest = (controlNumber, file, successCallback, mountedRef) => {
  const body = new FormData();
  body.append('file', file);
  return WebApiRequest({
    method: HTTP_POST,
    endpoint: ho.uploadAttachment(controlNumber, 0),
    successCallback,
    mountedRef,
    options: {
      headers: {
        'Content-Type': null,
      },
      body,
    },
  });
};
export const getCustomerDetailedHistory = (controlNumber, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: ho.customerDetailedHistory(controlNumber),
  successCallback,
  mountedRef,
});

export const getCustomerDetailedHistoryCoalesced = (controlNumber, successCallback, errorCallback = null) =>
  customerDetailedHistoryCoalescer.run(
    controlNumber,
    (resolve) => getCustomerDetailedHistory(controlNumber, resolve, activeRequest),
    successCallback,
    errorCallback,
  );
export const getCaseHeader = (controlNumber, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: ho.caseHeaderV2(controlNumber),
  successCallback,
  mountedRef,
});
export const updateCaseHeader = (controlNumber, body, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_PUT,
  endpoint: ho.caseHeaderV2(controlNumber),
  payload: body,
  successCallback,
  mountedRef,
});
export const getCaseFormCaseHeader = (controlNumber, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: ho.header(controlNumber),
  successCallback,
  mountedRef,
});
export const updateCaseHeaderDep = (controlNumber, body, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_PUT,
  endpoint: `/homeowner/cases/${controlNumber}/header/`,
  payload: body,
  successCallback,
  mountedRef,
});
export const getPhoenixFormVersion = (controlNumber, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: ho.getPhoenixFormVersion(controlNumber),
  successCallback,
  mountedRef,
});
export const getAppraisalFormData = (controlNumber, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: ho.getAppraisalFormData(controlNumber), // same endpoint as 1004p
  successCallback,
  mountedRef,
});
export const setAppraisalFormData = (controlNumber, payload, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_POST,
  endpoint: ho.setAppraisalFormData(controlNumber), // same endpoint as 1004p
  payload,
  successCallback,
  mountedRef,
});
export const downloadFileAttachments = (controlNumber, type, filename, successCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: ho.downloadFileAttachments(controlNumber, type, filename),
  successCallback,
  mountedRef,
});
export const getCubiCasaSketch = (controlNumber, successCallback, errorCallback, mountedRef) => WebApiRequest({
  method: HTTP_GET,
  endpoint: ho.caseForm(controlNumber, "cubiCasa"),
  successCallback,
  errorCallback,
  mountedRef,
});
export const reAddCaseForms = (controlNumber, caseFormId, mountedRef, successCallback, errorCallback) => WebApiRequest({
  method: HTTP_PUT,
  endpoint: ho.reAddCaseForms(caseFormId, controlNumber),
  successCallback,
  mountedRef,
  errorCallback,
});
